"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormRadioGroup = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _server = require("@whitbread-eos/utils/server");
var React = _interopRequireWildcard(require("react"));
var _Label = require("../../Label");
var _RadioGroup = require("../../RadioGroup");
var _index = require("../../Tooltip/index");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["items", "onChange", "errors", "variant", "selectedValue", "name", "errorIcon", "radioGroupItemClass", "radioGroupLabelClass", "radioGroupButtonClass", "customId", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FormRadioGroupItem = _ref => {
  var {
    value,
    label,
    variant = 'default',
    selectedValue,
    radioGroupItemClass,
    radioGroupLabelClass,
    radioGroupButtonClass,
    customId
  } = _ref;
  var isSelectedValue = selectedValue === value;
  var variantBoxStyle = () => {
    switch (variant) {
      case 'col-styled':
        return (0, _server.cn)(radioGroupItemStyle, colItemStyledStyle, radioGroupItemClass, isSelectedValue ? selectedOptionStyled : '');
      case 'row':
        return (0, _server.cn)(radioGroupItemStyleAddressVariant, isSelectedValue ? 'outline outline-2 outline-primaryColor -outline-offset-2 first:rounded-l-sm last:rounded-r-sm' : '');
      default:
        return (0, _server.cn)(radioGroupItemStyle, radioGroupItemClass);
    }
  };
  var variantItemStyle = () => {
    switch (variant) {
      case 'col-styled':
        return (0, _server.cn)('border-2 self-start mt-[2px]', isSelectedValue ? selectedOptionBulletStyle : 'border-lightGrey1');
      case 'row':
        return (0, _server.cn)(isSelectedValue ? 'border-2 border-primaryColor' : 'border-2 border-lightGrey1');
      default:
        return '';
    }
  };
  var variantBulletStyle = () => {
    switch (variant) {
      case 'col-styled':
        return (0, _server.cn)('fill-primaryColor text-primaryColor');
      case 'row':
        return (0, _server.cn)('fill-primaryColor text-primaryColor');
      default:
        return '';
    }
  };
  var variantLabelStyle = () => {
    switch (variant) {
      case 'col-styled':
        return (0, _server.cn)(radioGroupItemLabelStyle);
      case 'row':
        return (0, _server.cn)(radioGroupItemLabelStyle);
      default:
        return (0, _server.cn)(radioGroupItemLabelStyle, radioGroupLabelClass);
    }
  };
  return (0, _jsxRuntime.jsxs)(_Label.Label, {
    htmlFor: customId ? customId : value,
    className: variantBoxStyle(),
    children: [(0, _jsxRuntime.jsx)(_RadioGroup.RadioGroupItem, {
      value: value,
      id: customId ? customId : value,
      className: variantItemStyle(),
      bulletFillStyle: variantBulletStyle(),
      variant: variant,
      radioGroupButtonClass: radioGroupButtonClass
    }), (0, _jsxRuntime.jsx)("div", {
      className: variantLabelStyle(),
      id: customId ? customId : value,
      children: label
    })]
  });
};
var FormRadioGroup = exports.FormRadioGroup = React.forwardRef((_ref2, ref) => {
  var {
      items,
      onChange,
      errors,
      variant = 'default',
      selectedValue,
      name = 'radioName',
      errorIcon,
      radioGroupItemClass,
      radioGroupLabelClass,
      radioGroupButtonClass,
      customId,
      className
    } = _ref2,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var error = errors === null || errors === void 0 ? void 0 : errors[name];
  var hasError = !!(error !== null && error !== void 0 && error.type);
  var variantStyle = () => {
    switch (variant) {
      case 'col-styled':
        return 'gap-0';
      case 'row':
        return 'w-full flex flex-row justify-between gap-0';
      default:
        return '';
    }
  };
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_RadioGroup.RadioGroup, _objectSpread(_objectSpread({
      ref: ref,
      onValueChange: onChange,
      className: (0, _server.cn)(radioGroupStyle, variantStyle(), className),
      hasError: hasError
    }, props), {}, {
      children: items.map((item, index) => (0, _jsxRuntime.jsx)(FormRadioGroupItem, {
        value: item.value,
        label: item.label,
        variant: variant,
        selectedValue: selectedValue,
        radioGroupItemClass: radioGroupItemClass,
        radioGroupLabelClass: radioGroupLabelClass,
        radioGroupButtonClass: radioGroupButtonClass,
        customId: customId ? "".concat(customId, "-").concat(index + 1) : undefined,
        hasError: hasError
      }, item.value))
    })), (0, _jsxRuntime.jsx)(_index.ErrorTooltip, {
      icon: errorIcon,
      content: error === null || error === void 0 ? void 0 : error.message,
      open: hasError,
      testId: "".concat(name, "-Error-Tooltip"),
      className: "!flex",
      mobile: true
    })]
  });
});
FormRadioGroup.displayName = _RadioGroup.RadioGroup.displayName;
var radioGroupStyle = 'mt-2';
var radioGroupItemStyle = 'flex items-center space-x-2 h-14 cursor-pointer';
var radioGroupItemStyleAddressVariant = 'flex w-full space-x-2 h-14 p-5 items-center cursor-pointer border border-lightGrey3';
var radioGroupItemLabelStyle = 'font-semibold text-base cursor-pointer';
var colItemStyledStyle = 'border border-t-0 first:border-t p-4 bg-white first:rounded-t last:rounded-b h-[unset]';
var selectedOptionStyled = 'outline outline-2 outline-primaryColor -outline-offset-2';
var selectedOptionBulletStyle = 'color-primaryColor border-primaryColor';